export const MAP_DEFAULT_OPTIONS = {
  center: [120.1552, 30.2741],
  zoom: 4,
  minZoom: 1,
  maxZoom: 10,
  extent: [70, -11, 150, 60],
};

export const EPSG3857 = "EPSG:3857";
export const EPSG4326 = "EPSG:4326";

export const START_POINT = [120.212998, 30.291331];
